import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MemberRegistrationRequest } from '../models/member-registration-request';
import { MemberRegistrationResponse } from '../models/member-registration-response';
import { GetAllMembersResponse } from '../models/get-all-members-response';
import { environment } from '../../environments/environment';
import { CompleteMemberRegistrationRequest } from '../models/complete-member-registration-request';

@Injectable({
  providedIn: 'root'
})
export class MemberService {

  constructor(private http: HttpClient) { }

  getMembers() {
    return this.http.get<GetAllMembersResponse>(environment.apiUrl + '/members');
  }

  registerMember(member: MemberRegistrationRequest) {
    return this.http.post<MemberRegistrationResponse>(environment.apiUrl + '/members/register', member);
  }

  complteteMemberRegistration(member: CompleteMemberRegistrationRequest) {
    return this.http.post<MemberRegistrationResponse>(environment.apiUrl + '/members/register/complete', member);
  }

  removeMember(tvxPlusId: string) {
    return this.http.delete(environment.apiUrl + `/members/${tvxPlusId}`);
  }
}
